import basicBadge from "~/assets/badges/basic.png";
import premiumBadge from "~/assets/badges/premium.png";
import superiorBadge from "~/assets/badges/superior.png";

interface LocationPlanBadgeProps {
  plan: string;
  contrastSave?: boolean;
  className?: string;
}

const badgeMap: Record<string, string> = {
  basic: basicBadge,
  premium: premiumBadge,
  superior: superiorBadge,
};

export function LocationPlanBadge({
  plan,
  className,
  contrastSave,
}: LocationPlanBadgeProps) {
  const badgeSrc = badgeMap[plan.toLowerCase()];

  if (!badgeSrc) {
    return null;
  }

  const capitalizedPlan = plan.charAt(0).toUpperCase() + plan.slice(1);

  if (contrastSave && plan === "basic") {
    return (
      <span className="bg-white shadow rounded-md px-0.5 inline-block">
        <img src={badgeSrc} alt={capitalizedPlan} className={className} />
      </span>
    );
  }
  return <img src={badgeSrc} alt={capitalizedPlan} className={className} />;
}
